
    import { defineComponent } from 'vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    const CYBER_MONDAY = {
        from: new Date('2026-11-02T00:00:00'),
        toExclusive: new Date('2026-11-09T00:00:00'),
        icon: '/Logos/cyber-monday.svg',
        byProduct: {
            'Hogar': {
                title: 'Protegé tu Hogar con 30% OFF en el CYBER MONDAY',
                subtitle: 'Tu casa siempre segura con un ahorro extra por tiempo limitado.',
            },
            'Bici o Monopatín': {
                title: 'Movilidad con 15% OFF en el CYBER MONDAY',
                subtitle: 'Asegurá tu bici o monopatín con un beneficio especial por tiempo limitado.',
            },
            'Salud': {
                title: '30% OFF en el CYBER MONDAY',
                subtitle: 'Cuidarte es más fácil con descuentos exclusivos por tiempo limitado.',
            },
            'AP 24HS': {
                title: '30% OFF en el CYBER MONDAY',
                subtitle: 'Cuidarte es más fácil con descuentos exclusivos por tiempo limitado.',
            },
        } as Record<string, { title: string; subtitle: string }>,
    };

    export default defineComponent({
        name: 'TitlesAndPromotions',
        props: {
            titleAndPromotionDetails: {
                type: Object as () => TitleAndPromotionsDetails,
                required: true,
            }
        },
        data() {
            return {
                dataDiscount: {
                    discountRate: null,
                    containDiscountRange: false,
                    changeTitlePromotions: false,
                },
            }
        },
        computed: {
            cyberMondayPromo() {
                const now = new Date();
                if (now < CYBER_MONDAY.from || now >= CYBER_MONDAY.toExclusive) {
                    return null;
                }
                const copy = CYBER_MONDAY.byProduct[this.titleAndPromotionDetails.product];
                return copy ? { ...copy, icon: CYBER_MONDAY.icon } : null;
            },
        },
        methods: {
            setDiscountData(data) {
                this.dataDiscount = { ...data };
            },
        },
    });
